import { createReducer } from 'redux-act';
import { EXPIRED_TOKEN_ERROR } from 'config/constants';
import {
  expireSBAAuthentication,
  createSBAAuthenticationFailure,
  removeSBAAuthentication,
  createSBAAuthenticationSuccess,
  updateSBAAuthentication,
  updateSBAIsAuthenticatingState,
} from './actions';

export const initialState = {
  isAuthenticating: false,
  isAuthenticated: false,
  token: null,
  error: null,
};

const updateUserToken = ({ sbaUser, ...state }, payload) => ({
  ...state,
  sbaUser: {
    ...sbaUser,
    isAuthenticated: !!payload.token,
    token: payload.token,
    error: undefined,
  },
});

export const reducerBranches = {
  [updateSBAIsAuthenticatingState]: ({ sbaUser, ...state }, payload) => ({
    ...state,
    sbaUser: {
      ...sbaUser,
      isAuthenticating: payload.isAuthenticating,
    },
  }),
  [createSBAAuthenticationSuccess]: updateUserToken,
  [updateSBAAuthentication]: updateUserToken,
  [removeSBAAuthentication]: ({ sbaUser, ...state }) => ({
    ...state,
    sbaUser: {
      ...sbaUser,
      isAuthenticated: false,
      token: undefined,
      error: undefined,
    },
  }),
  [createSBAAuthenticationFailure]: ({ sbaUser, ...state }, payload) => ({
    ...state,
    sbaUser: {
      ...sbaUser,
      isAuthenticated: false,
      token: undefined,
      error: payload.error,
    },
  }),
  [expireSBAAuthentication]: ({ sbaUser, ...state }) => ({
    ...state,
    sbaUser: {
      ...sbaUser,
      isAuthenticated: false,
      token: undefined,
      error: new Error(EXPIRED_TOKEN_ERROR),
    },
  }),
};

const sbaAuthenticationReducer = createReducer(reducerBranches, { sbaUser: initialState });

export default sbaAuthenticationReducer;
